(function () {
  'use strict';

  angular.module('checker.core', [
    'ngSanitize'
  ]);

})();
